module.exports = __webpack_public_path__ + "img/naver_logo.10f1060a.png";